import { watch } from "vue";
import { useMate } from "@/stores/mate";
import { Mate } from "@/types/entity";
import { useGlobalUser } from "@/stores/globalUser";

export const onCurrentMateChange = (
  cb: (
    newValue: [Mate | null, isLogin: boolean],
    oldValue: [Mate | null, isLogin: boolean]
  ) => void
) => {
  const mate = useMate();
  const user = useGlobalUser();
  watch(
    [() => mate.currentMate as Mate | null, () => user.isLogin],
    (newVal, oldVal) => {
      cb(newVal, oldVal);
    },
    { flush: "post" }
  );
  // mate.$subscribe((mutation) => {
  //   let event: DebuggerEvent | undefined = mutation.events as DebuggerEvent;
  //   if (mutation.events instanceof Array) {
  //     event = mutation.events.find((item) => item.key === '"currentMate"');
  //   }
  //   if (event && event.key === "currentMate") {
  //     cb(event.newValue as Mate | null, event.oldValue as Mate | null);
  //   }
  // });
};
